export default {
  'storeManagement.title': 'Store List',
  'storeManagement.form.merchantName': 'Merchant Name',
  'storeManagement.form.merchantName.placeholder': 'Please enter merchant name',
  'storeManagement.form.shopName': 'Store Name',
  'storeManagement.form.shopName.placeholder': 'Please enter store name',
  'storeManagement.form.search': 'Search',
  'storeManagement.form.reset': 'Reset',
  'storeManagement.operation.add': 'Add',
  'storeManagement.operation.editMerchant': 'Edit Merchant',
  'storeManagement.operation.delete': 'Delete',
  'storeManagement.operation.export': 'Export',
  'storeManagement.operation.batchDeleteConfirm':
    'Are you sure you want to delete the selected stores?',
  'storeManagement.operation.noSelection':
    'Please select stores to operate first',
  'storeManagement.operation.batchDeleteSuccess': 'Batch delete successful',
  'storeManagement.operation.batchDeleteFailed': 'Batch delete failed',
  'storeManagement.operation.restore': 'Restore',
  'storeManagement.operation.batchRestoreConfirm':
    'Are you sure you want to restore the selected stores?',
  'storeManagement.operation.batchRestoreSuccess': 'Batch restore successful',
  'storeManagement.operation.batchRestoreFailed': 'Batch restore failed',
  'storeManagement.operation.migrateToBackup': 'Migrate to Backup',
  'storeManagement.operation.migrateToBackupConfirm':
    'Are you sure you want to migrate the selected stores to backup stores?',
  'storeManagement.operation.migrateToBackupSuccess':
    'Migrated to backup stores successfully',
  'storeManagement.operation.migrateToBackupFailed':
    'Failed to migrate to backup stores',
  'storeManagement.operation.migrateToNormal': 'Migrate to Normal',
  'storeManagement.operation.migrateToNormalConfirm':
    'Are you sure you want to migrate the selected stores to normal stores?',
  'storeManagement.operation.migrateToNormalSuccess':
    'Migrated to normal stores successfully',
  'storeManagement.operation.migrateToNormalFailed':
    'Failed to migrate to normal stores',
  'storeManagement.columns.index': 'Index',
  'storeManagement.columns.merchantName': 'Merchant Name',
  'storeManagement.columns.shopName': 'Store Name',
  'storeManagement.columns.shopifyId': 'Shopify ID',
  'storeManagement.columns.operationName': 'Operation Name',
  'storeManagement.columns.shopApi': 'Store API',
  'storeManagement.columns.paypalApi': 'Paypal Configuration',
  'storeManagement.columns.ccApi': 'Credit Card Configuration',
  'storeManagement.columns.scApi': 'Renewal Credit Card Configuration',
  'storeManagement.columns.walletApi': 'Wallet Configuration',
  'storeManagement.columns.upsellSetting': 'Upsell Configuration',
  'storeManagement.columns.status': 'Status',
  'storeManagement.columns.status.enabled': 'Enabled',
  'storeManagement.columns.status.disabled': 'Not Installed',
  'storeManagement.columns.remarks': 'Remarks',
  'storeManagement.columns.createdAt': 'Created At',
  'storeManagement.columns.updatedAt': 'Updated At',
  'storeManagement.columns.notConfigured': 'Not Configured',
  'storeManagement.columns.operations': 'Operations',
  'storeManagement.columns.operations.edit': 'Edit',
  'storeManagement.columns.operations.delete': 'Delete',
  'storeManagement.columns.operations.deleteConfirm':
    'Are you sure you want to delete this record?',
  'storeManagement.columns.operations.restore': 'Restore',
  'storeManagement.columns.operations.restoreConfirm':
    'Are you sure you want to restore this store? It will return to its state before deletion.',
  'storeManagement.columns.storeType': 'Store Type',
  'storeManagement.columns.storeType.normal': 'Normal Store',
  'storeManagement.columns.storeType.backup': 'Backup Store',
  'storeManagement.columns.configured': 'Configured',
  'storeManagement.actions.refresh': 'Refresh',
  'storeManagement.actions.density': 'Density',
  'storeManagement.actions.columnSetting': 'Column Setting',
  'storeManagement.operation.download': 'Download',
  'storeManagement.size.mini': 'Mini',
  'storeManagement.size.small': 'Small',
  'storeManagement.size.medium': 'Medium',
  'storeManagement.size.large': 'Large',
  'storeManagement.modal.title': 'Store Information',
  'storeManagement.modal.shopName': 'Store Name',
  'storeManagement.modal.shopName.placeholder': 'Please enter store name',
  'storeManagement.modal.shopName.required': 'Please enter store name',
  'storeManagement.modal.merchant': 'Affiliated Merchant',
  'storeManagement.modal.merchant.placeholder':
    'Please enter affiliated merchant',
  'storeManagement.modal.merchant.required':
    'Please select affiliated merchant',
  'storeManagement.modal.shopifyId': 'Shopify ID',
  'storeManagement.modal.shopifyId.placeholder': 'Please enter Shopify ID',
  'storeManagement.modal.shopifyId.required': 'Please enter Shopify ID',
  'storeManagement.modal.remarks': 'Remarks',
  'storeManagement.modal.remarks.placeholder':
    'Please enter remarks information',
  'storeManagement.modal.createSuccess': 'Created successfully',
  'storeManagement.modal.createFailed': 'Failed to create',
  'storeManagement.shopApiModal.title': 'Shop API',
  'storeManagement.shopApiModal.appName': 'App Name',
  'storeManagement.shopApiModal.appName.placeholder': 'Please enter App Name',
  'storeManagement.shopApiModal.appName.required': 'Please enter App Name',
  'storeManagement.shopApiModal.adminApiAccessToken': 'Admin Token',
  'storeManagement.shopApiModal.adminApiAccessToken.placeholder':
    'Will be filled automatically after installing the app, no need to fill',
  'storeManagement.shopApiModal.storefrontApiAccessToken': 'Storefront Token',
  'storeManagement.shopApiModal.storefrontApiPrivateToken': 'Storefront Private Token',
  'storeManagement.shopApiModal.storefrontApiAccessToken.placeholder':
    'Please enter Storefront Token',
  'storeManagement.shopApiModal.storefrontApiPrivateToken.placeholder':
    'Please enter Storefront Private Token',
  'storeManagement.shopApiModal.clientId': 'Partner Client ID',
  'storeManagement.shopApiModal.clientId.placeholder':
    'Please enter Partner Client ID',
  'storeManagement.shopApiModal.clientId.required':
    'Please enter Partner Client ID',
  'storeManagement.shopApiModal.clientSecret': 'Partner Client Secret',
  'storeManagement.shopApiModal.clientSecret.placeholder':
    'Please enter Partner Client Secret',
  'storeManagement.shopApiModal.clientSecret.required':
    'Please enter Partner Client Secret',
  'storeManagement.shopApiModal.merchant': 'Affiliated Merchant',
  'storeManagement.shopApiModal.merchant.placeholder':
    'Please enter affiliated merchant',
  'storeManagement.shopApiModal.merchant.required':
    'Please select affiliated merchant',
  'storeManagement.shopApiModal.googlePlacesApiKey': 'Google Places Key',
  'storeManagement.shopApiModal.googlePlacesApiKey.placeholder':
    'Please enter Google Places Key',
  'storeManagement.shopApiModal.callbackApiDomain': 'Callback API Domain',
  'storeManagement.shopApiModal.callbackApiDomain.placeholder':
    'Please enter Callback API Domain',
  'storeManagement.shopApiModal.appStatus': 'App Status',
  'storeManagement.shopApiModal.appStatus.placeholder': 'Please select status',
  'storeManagement.shopApiModal.appStatus.enabled': 'Enabled',
  'storeManagement.shopApiModal.appStatus.disabled': 'Not Installed',
  'storeManagement.shopApiModal.appStatus.installHint':
    'Only "Not Installed" stores can be installed. Not installed stores cannot be changed to enabled.',
  'storeManagement.shopApiModal.saveSuccess': 'Saved successfully',
  'storeManagement.shopApiModal.saveFailed': 'Failed to save',
  'storeManagement.shopApiModal.deleteSuccess': 'Deleted successfully',
  'storeManagement.shopApiModal.deleteFailed': 'Failed to delete',
  'storeManagement.shopApiModal.deleteConfirm':
    'Are you sure you want to clear the shop configuration?',
  'storeManagement.paymentModal.paypal.title': 'Paypal Configuration',
  'storeManagement.paymentModal.card.title': 'Credit Card Configuration',
  'storeManagement.paymentModal.scCard.title':
    'Renewal Credit Card Configuration',
  'storeManagement.paymentModal.wallet.title': 'Wallet Configuration',
  'storeManagement.paymentModal.upsell.title': 'Upsell Configuration',
  'storeManagement.editMerchantModal.title': 'Batch Edit Merchants',
  'storeManagement.editMerchantModal.merchant': 'Select Merchant',
  'storeManagement.editMerchantModal.merchant.placeholder':
    'Please select merchant',
  'storeManagement.editMerchantModal.merchant.required':
    'Please select merchant',
  'storeManagement.editMerchantModal.noSelection':
    'Please select stores to edit first',
  'storeManagement.editMerchantModal.success': 'Batch edit successful',
  'storeManagement.editMerchantModal.failed': 'Batch edit failed',
  'storeManagement.deleteSuccess': 'Deleted successfully',
  'storeManagement.deleteFailed': 'Failed to delete',
  'storeManagement.restoreSuccess': 'Restored successfully',
  'storeManagement.restoreFailed': 'Failed to restore',
  'storeManagement.columns.email': 'Email Configuration',
  'storeManagement.emailModal.title': 'Email Configuration',
  'storeManagement.emailModal.email': 'Email',
  'storeManagement.emailModal.formEmail.required': 'Please enter email',
  'storeManagement.emailModal.emailKey': 'Email Key',
  'storeManagement.emailModal.emailKey.required': 'Please enter email key',
  'storeManagement.emailModal.port': 'Port',
  'storeManagement.emailModal.port.required': 'Please enter port',
  'storeManagement.emailModal.host': 'Host',
  'storeManagement.emailModal.host.required': 'Please enter host',
  'storeManagement.emailModal.ssl': 'SSL',
  'storeManagement.emailModal.ssl.required': 'Please enter ssl',
  'storeManagement.emailModal.tls': 'TLS',
  'storeManagement.emailModal.tls.required': 'Please enter tls',
  'storeManagement.emailModal.saveSuccess': 'Saved successfully',
  'storeManagement.emailModal.saveFailed': 'Failed to save',
  'storeManagement.emailModal.deleteSuccess': 'Deleted successfully',
  'storeManagement.emailModal.deleteFailed': 'Failed to delete',
  'storeManagement.emailModal.deleteConfirm': 'Are you sure you want to delete the email configuration?',
  'storeManagement.emailModal.edit': 'Edit',
  'storeManagement.emailModal.delete': 'Delete',
  'storeManagement.emailModal.formEmail': 'Form Email',
  'storeManagement.emailModal.protocol': 'Protocol',
  'storeManagement.emailModal.protocol.required': 'Please select protocol',
  'storeManagement.emailModal.acceptEmail': 'Recipient Email',
  'storeManagement.emailModal.acceptEmail.required':
    'Please enter the email to receive the verification code',
  'storeManagement.emailModal.acceptEmail.invalid':
    'Please enter a valid email address',
  'storeManagement.emailModal.verifyCode': 'Verification Code',
  'storeManagement.emailModal.verifyCode.required':
    'Please enter the verification code',
  'storeManagement.emailModal.sendCode': 'Send Code',
  'storeManagement.emailModal.verify': 'Verify',
  'storeManagement.emailModal.sendCodeSuccess':
    'Verification code sent. Please check your inbox.',
  'storeManagement.emailModal.sendCodeFailed': 'Failed to send verification code',
  'storeManagement.emailModal.verifySuccess':
    'Email configuration verified. You can save now.',
  'storeManagement.emailModal.verifyFailed':
    'Invalid or expired verification code',
  'storeManagement.emailModal.verifyRequired':
    'Please verify the email configuration first',
};
